import { useContext } from "react";
import { ListChainHeader, ToolTipSwichChain } from "../styled";
import { useDispatch } from "../../../../store/store";
import { getActiveChain } from "../../../../store/features/poolsSlice";
import { ContextProviderWrapper } from "../../../Context";
import { Link, useNavigate } from "react-router-dom";
import { useDisconnect } from "@reown/appkit/react";
import { switchDefaultTokens } from "../../../../constant";
import { useTonAddress, useTonConnectUI } from "@tonconnect/ui-react";

const SwitchChain = ({ listChain, chainRouter }: any) => {
  const { theme } = useContext(ContextProviderWrapper)!;
  const dispatch = useDispatch();
  const { disconnect } = useDisconnect();
  const navigate = useNavigate();
  const [tonConnectUI] = useTonConnectUI();
  const addressTon = useTonAddress();

  return (
    <ToolTipSwichChain className={theme}>
      <div className="tooltipTitle">Select Chain</div>
      <ListChainHeader>
        {listChain.map((item: any, index: number) => {
          return (
            <li
              key={index}
              className={
                item.disable
                  ? "close"
                  : `${
                      item.name.toLowerCase() === chainRouter.toLowerCase()
                        ? "active"
                        : ""
                    }`
              }
              onClick={() => {
                dispatch(getActiveChain(item.name));
                localStorage.clear();
                disconnect();
                if (addressTon) {
                  tonConnectUI.disconnect();
                }
                const from = switchDefaultTokens(item.name)?.fromAddress;
                const to = switchDefaultTokens(item.name)?.toAddress;
                const convertName =
                  item.name === "Avalanche"
                    ? "avax"
                    : item.name === "Toncoin"
                    ? "ton"
                    : item.name;
                navigate(
                  `/swap/${convertName.toLowerCase()}?from=${from}&to=${to}`
                );
              }}
            >
              <Link to={"#"}>
                <h4
                  style={{
                    color: theme === "dark" ? "#fff" : "#000",
                  }}
                >
                  <figure>
                    <img src={item?.logoUrl} alt="icon" />
                  </figure>
                  {item.name}
                </h4>
                {!item.disable &&
                  item.name.toLowerCase() === chainRouter.toLowerCase() && (
                    <img src="/static/charm_tick.svg" alt="icon" />
                  )}
              </Link>
            </li>
          );
        })}
      </ListChainHeader>
    </ToolTipSwichChain>
  );
};

export default SwitchChain;
